module.exports = __webpack_public_path__ + "public/img/yibiaopan_lan_3.e36aeba7.png";